module.exports = __webpack_public_path__ + "img/error.95526eaf.svg";